import React, { useRef } from "react";
import { Box } from "@mui/material";
import { RecUploadIcon } from "assets";
import { PdfUploadEmptyDataProps } from "./types";

export const PdfUploadEmptyData: React.FunctionComponent<
  PdfUploadEmptyDataProps
> = ({ onFileSelected }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) onFileSelected(file);
  };

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <Box
      sx={{
        textAlign: "center",
        position: "absolute",
        backgroundColor: "white",
      }}
    >
      <RecUploadIcon
        width={84}
        height={84}
        onClick={handleIconClick}
        style={{ cursor: "pointer" }}
      />
      <input
        type="file"
        accept=".pdf"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
    </Box>
  );
};
